module.exports = __webpack_public_path__ + "d527c3a9648bde9c6afd758605bf4e7a.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/brand_ambassadors/rose_gold_macbook.png
// module id = 569
// module chunks = 0